var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Group 18616",
  viewBox: "0 0 15 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19753"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z",
  "data-name": "Rectangle 7433"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 27402"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.563.332A7.231 7.231 0 1 1 .332 7.563 7.23 7.23 0 0 1 7.563.332"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.5,
  d: "M7.563 1.082a6.49 6.49 0 0 0-6.481 6.481 6.49 6.49 0 0 0 6.481 6.481 6.49 6.49 0 0 0 6.481-6.48 6.49 6.49 0 0 0-6.48-6.482m0-.75a7.231 7.231 0 1 1 0 14.462 7.231 7.231 0 0 1 0-14.462Z"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  "data-name": "Group 19752"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.113 4.579 4.541 8.36a1.3 1.3 0 0 0-.291.622l-.164 1.41a.664.664 0 0 0 .814.77l1.4-.239a1.25 1.25 0 0 0 .6-.326l3.572-3.781a1.417 1.417 0 0 0-.065-2.306 1.418 1.418 0 0 0-2.294.069",
  "data-name": "Path 27106"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.517 5.209A2.665 2.665 0 0 0 9.888 7.45",
  "data-name": "Path 27107"
})))));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.1cf351a3b23661c956288d5c348ebb8e.svg";